import { HCO_CUBE_NAME } from '@/api/hco/constants';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { STATE_PROVINCE_FILTER_LIMIT } from '../../filterDefaultLimits';

const HCO_STATE_PROVINCE_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.state_province`],
  limit: STATE_PROVINCE_FILTER_LIMIT,
});

const hcoStateProvinceFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcoStateProvinceLabel',
  placeholder: 'global.filters.formControls.hcoStateProvincePlaceholder',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  applyDynamicFilters: true,
  sourceCube: HCO_CUBE_NAME,
  getOptionsQuery: HCO_STATE_PROVINCE_OPTIONS,
  mapResult: mapDimensionToOption(`${HCO_CUBE_NAME}.state_province`),
  applyFilter: value => {
    const selected = Array.isArray(value) ? value.map(String) : [];
    if (selected.length === 0) return undefined;
    return {
      member: `${HCO_CUBE_NAME}.state_province`,
      operator: 'equals',
      values: selected,
    };
  },
};

export default hcoStateProvinceFilter;
